export class ForceDeleteSnapshotsRequest {
    'snapshotIds';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotIds",
            "baseName": "snapshotIds",
            "type": "Array<string>",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return ForceDeleteSnapshotsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
